<template>
    <div class="tile-container">
        <div class="max-container">
            <div class="row no-gutters">
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Impressions served"
                        text="Ad impressions<br>served"
                        :number="totalImpressions"
                        icon="ads-served"
                        :percent="totalImpressionsPercent"
                        :target="totalImpressionsTarget"
                        :flip="true"
                        color="green"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="CTR (No. of clicks)"
                        text="Click-through rate<br>(Number of adverts clicked)"
                        :number="totalCTR"
                        :secondNumber="totalClicks"
                        :percent="totalCTRPercent"
                        :target="totalCTRTarget"
                        :flip="true"
                        :percentage="true"
                        color="blue"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Visits to LP"
                        text="Visits to<br>campaign landing page"
                        :number="totalVisits"
                        icon="monitor"
                        :percent="totalVisitsPercent"
                        :target="totalVisitsTarget"
                        :flip="true"
                        color="teal"
                    ></stat-tile>
                </div>
                <div class="tile-wrapper col-6 col-md-3">
                    <stat-tile
                        class="tile"
                        mobileText="Average time on site"
                        text="Average time<br>spend on site"
                        :time="averageTime"
                        icon="clock"
                        :percent="averageTimePercent"
                        :target="averageTimeTarget"
                        :flip="true"
                        color="pink"
                    ></stat-tile>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import StatTile from '@/components/tiles/StatTile';

    export default {
        components: {
            StatTile,
        },
        computed: {
            totalCTRTarget() {
                if (store.state.chartData.totalCTRTarget) {
                    return store.state.chartData.totalCTRTarget;
                }

                return 0;
            },
            totalClicksTarget() {
                if (store.state.chartData.totalClicksTarget) {
                    return store.state.chartData.totalClicksTarget;
                }

                return 0;
            },
            totalImpressionsTarget() {
                if (store.state.chartData.totalImpressionsTarget) {
                    return store.state.chartData.totalImpressionsTarget;
                }

                return 0;
            },
            totalVisitsTarget() {
                if (store.state.chartData.totalVisitsTarget) {
                    return store.state.chartData.totalVisitsTarget;
                }

                return 0;
            },
            totalCTRPercent() {
                if (store.state.chartData.totalCTRPercent) {
                    return store.state.chartData.totalCTRPercent;
                }

                return 0;
            },
            totalClicksPercent() {
                if (store.state.chartData.totalClicksPercent) {
                    return store.state.chartData.totalClicksPercent;
                }

                return 0;
            },
            totalImpressionsPercent() {
                if (store.state.chartData.totalImpressionsPercent) {
                    return store.state.chartData.totalImpressionsPercent;
                }

                return 0;
            },
            totalVisitsPercent() {
                if (store.state.chartData.totalVisitsPercent) {
                    return store.state.chartData.totalVisitsPercent;
                }

                return 0;
            },
            averageTimePercent() {
                if (store.state.chartData.averageTimePercent) {
                    return store.state.chartData.averageTimePercent;
                }

                return 0;
            },
            totalCTR() {
                if (store.state.chartData.totalCTR) {
                    return store.state.chartData.totalCTR;
                }

                return 0;
            },
            totalClicks() {
                if (store.state.chartData.totalClicks) {
                    return store.state.chartData.totalClicks;
                }

                return 0;
            },
            totalImpressions() {
                if (store.state.chartData.totalImpressions) {
                    return store.state.chartData.totalImpressions;
                }

                return 0;
            },
            benchmark() {
                if (store.state.chartData.industryBenchmark) {
                    return store.state.chartData.industryBenchmark;
                }

                return 0;
            },
            totalVisits() {
                if (store.state.chartData.totalVisits) {
                    return store.state.chartData.totalVisits;
                }

                return 0;
            },
            averageTime() {
                if (store.state.chartData.averageTime) {
                    const time = store.state.chartData.averageTime;

                    const hours = time.h;
                    const minutes = time.m;
                    const seconds = time.s;

                    return {
                        hours,
                        minutes,
                        seconds,
                    };
                }

                return {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                };
            },
            averageTimeTarget() {
                if (store.state.chartData.averageTimeTarget) {
                    const time = store.state.chartData.averageTimeTarget;

                    const hours = time.h;
                    const minutes = time.m;
                    const seconds = time.s;

                    return {
                        hours,
                        minutes,
                        seconds,
                    };
                }

                return {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partials/variables';

    $margin-amount: 5;
    $margin: #{$margin-amount + 'px'};
    $margin-half: #{($margin-amount / 2) + 'px'};

    $margin-tablet-amount: 9.5;
    $margin-tablet: #{$margin-tablet-amount + 'px'};
    $margin-tablet-half: #{($margin-tablet-amount / 2) + 'px'};

    $margin-desktop-amount: 20;
    $margin-desktop: #{$margin-desktop-amount + 'px'};
    $margin-desktop-half: #{($margin-desktop-amount / 2) + 'px'};

    .tile-container {
        padding-bottom: 43px;
    }

    .tile-wrapper {
        &:nth-child(1) {
            .tile {
                background-color: $tileGreen-background;

                @media screen and (min-width: $tablet) {
                    margin-right: $margin-tablet-half;
                    border-bottom-width: 10px;
                }

                @media screen and (min-width: $desktop) {
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(2) {
            .tile {
                background-color: $tileBlue-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                    margin-right: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(3) {
            .tile {
                background-color: $tileTeal-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                    margin-right: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                    margin-right: $margin-desktop-half;
                }
            }
        }
        &:nth-child(4) {
            .tile {
                background-color: $tilePink-background;

                @media screen and (min-width: $tablet) {
                    margin-left: $margin-tablet-half;
                }

                @media screen and (min-width: $desktop) {
                    margin-left: $margin-desktop-half;
                }

                .percent-bar {
                    background-color: transparentize($tilePink-accent, 0.4);
                }
            }
        }
    }

    .tile {
        position: relative;
        height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/tiles/MediaTileContainer.vue